import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
const SyncConfigTable = ({ data, editClick }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  return (
    <TableContainer
      className="tableairp-responsive"
      style={{ maxHeight: "none", height: "100%", marginTop: "20px" }}
    >
      <Table className="table-airp">
        <TableHead>
          <TableRow className="laststick-tr">
            {TableHeaderName.map((item, index) => (
              <TableCell key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody className="laststick-tr">
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((item, index) => (
              <TableRow key={index} className="laststick-tr">
                <TableCell>{index + 1}.</TableCell>
                <TableCell>{item.paraMeterWego || "N/A"}</TableCell>
                <TableCell>{item.softValueWego || "N/A"}</TableCell>
                <TableCell>{item.outBoundAirlineWego || "N/A"}</TableCell>
                <TableCell>{item.paraMeterSky || "N/A"}</TableCell>
                <TableCell>{item.softValueSky || "N/A"}</TableCell>
                <TableCell>{item.outBoundAirlineSky || "N/A"}</TableCell>
                <TableCell>{item.paraMeterGoogle || "N/A"}</TableCell>
                <TableCell>{item.softValueGoogle || "N/A"}</TableCell>
                <TableCell>{item.outBoundAirlineGoogle || "N/A"}</TableCell>
                <TableCell>{item.maxDataSizeMB || "N/A"}</TableCell>{" "}
                <TableCell>{item.bookingDiscountCapIndia || "N/A"}</TableCell>
                <TableCell>
                  {item.bookingDiscountCapRestOfIndia || "N/A"}
                </TableCell>
                <TableCell className="lastrow">
                  <div className="me-2">
                    <IconButton
                      aria-label="edit"
                      color="success"
                      onClick={() => editClick(item)}
                    >
                      <EditIcon />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, page) => setPage(page)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(+e.target.value);
          setPage(0);
        }}
      />
    </TableContainer>
  );
};

export default SyncConfigTable;
const TableHeaderName = [
  "S.No.",
  "Wego Parameter",
  "Wego Soft Value",
  "Wego Outbound Airline",
  "Sky Parameter",
  "Sky Soft Value",
  "Sky Outbound Airline",
  "Google Parameter",
  "Google Soft Value",
  "Google Outbound Airline",
  "Max Data Size",
  "Booking Discount Cap India",
  "Booking Discount Cap Rest Of India",
  "Edit",
];
